import { render, staticRenderFns } from "./CoozzyDocumentIcon.vue?vue&type=template&id=1e83b30a&scoped=true"
import script from "./CoozzyDocumentIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyDocumentIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyDocumentIcon.vue?vue&type=style&index=0&id=1e83b30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e83b30a",
  null
  
)

export default component.exports